export const DATA_LAYER_NAME = 'dataLayer';

export const ANALYTICS_EVENTS = Object.freeze({
  FORM_SUBMISSION: 'form_submission',
  FORM_ERROR: 'form_error',
  FORM_PROGRESS: 'form_progress',
  FORM_INTERACTION: 'form_interaction',
});

export const FORM_EVENT_CATEGORIES = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  MULTI_STEP: 'multi-step',
});

export const FORM_EVENT_ACTIONS = Object.freeze({
  SINGLE_STEP_SUBMIT: 'single_step_submit',
  MULTI_STEP_SUBMIT: 'multi_step_submit',
  PROGRESS: 'progress',
  CHECKBOX_CLICK: 'checkbox_click',
  RADIO_CLICK: 'radio_click',
});

export const FORM_TYPES = Object.freeze({
  SINGLE_STEP: 'single_step',
  MULTI_STEP: 'multi_step',
});
